module.exports = __webpack_public_path__ + "img/world_freezer_small.3808ca2d.png";